exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav_bar[data-v-1b2aa649]{position:-webkit-sticky;position:sticky;top:0}.title[data-v-1b2aa649]{font-size:18px}", ""]);

// exports
